/**
 * Axios usually throws `response.data` (plain object). `message` may be string, array, or nested object.
 * Use for snackbars and Error() so UI never shows "[object Object]".
 */
export function formatApiMessage(e: unknown): string {
  if (e == null) return 'Unknown error';
  if (typeof e === 'string') return e;
  const o = e as Record<string, unknown>;
  const response = o.response as Record<string, unknown> | undefined;
  if (response?.data != null) return formatApiMessage(response.data);
  if (e instanceof Error && typeof e.message === 'string') return e.message;
  const m = o.message;
  if (typeof m === 'string') return m;
  if (Array.isArray(m)) return m.map(String).join('; ');
  if (m != null && typeof m === 'object') {
    try {
      return JSON.stringify(m);
    } catch {
      return String(m);
    }
  }
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
}
